import { createContext } from "react";

export interface INotificationContext {
  toggleMute: () => void;
  isMuted: boolean;
}

export const NotificationContext = createContext<INotificationContext>(
  {} as INotificationContext,
);
